<template>
  <div>
    <h1>WEBB</h1>      
  </div>
</template>

<script>
export default {
  name:'Start',
}
</script>